/**
 * Ce qui fait qu'une modale SE VOIT comme posee au-dessus de l'ecran.
 *
 * LE PROBLEME. `CBModal` pose `mask={false}` pour laisser l'utilisateur
 * interagir derriere : rc-dialog met alors `pointer-events: none` sur son
 * enveloppe, et la frappe traverse. Mais sans voile ni ombre, le panneau se
 * confond avec le contenu qu'il recouvre - rien ne dit qu'il flotte, et
 * l'utilisateur cherche a cliquer dans un tableau qui est en fait dessous.
 *
 * POURQUOI PAS `mask={true}`. Ce serait reprendre d'une main ce qu'on donne de
 * l'autre : le calque de masque capture les evenements de pointeur, et la frappe
 * derriere meurt. Le defaut d'origine reviendrait sous une autre forme.
 *
 * LA SOLUTION. Le voile est peint par une OMBRE a tres grand etalement
 * (`0 0 0 100vmax`), qui assombrit tout l'ecran autour du panneau. Une ombre ne
 * recoit aucun evenement de pointeur : on obtient le voile sans poser le moindre
 * noeud, et la frappe derriere reste intacte. `100vmax` couvre l'ecran dans les
 * deux orientations.
 *
 * Extrait du composant pour etre verifiable : le depot n'a pas de bibliotheque de
 * rendu, et ce qui n'est pas extrait n'est pas teste.
 */

/** Le voile qui assombrit l'ecran autour du panneau. */
export const VOILE = 'rgba(15, 23, 42, 0.18)';

/** Le liseré qui detache le panneau de ce qu'il recouvre. */
export const ANNEAU = 'rgba(26, 107, 60, 0.22)';

/** L'ombre portee, qui donne la hauteur. */
export const OMBRE = 'rgba(15, 23, 42, 0.38)';

/* Hauteur maximale du corps, au-dela de laquelle il defile.
   200 px couvrent l'en-tete du modal, ses marges hautes et basses, et la barre
   de titre du navigateur. */
const CORPS_DEFILANT = {
  maxHeight: 'calc(100vh - 200px)',
  overflowY: 'auto',
};

const ELEVATION = [
  `0 24px 64px -12px ${OMBRE}`,
  `0 0 0 1px ${ANNEAU}`,
  `0 0 0 100vmax ${VOILE}`,
].join(', ');

/**
 * Les `styles` a passer a `Modal`, voile et defilement compris.
 *
 * Les styles de l'appelant restent prioritaires : ils sont etales en dernier,
 * cle par cle. Un appelant qui veut `boxShadow: 'none'` l'obtient - c'est son
 * droit, et c'est explicite.
 */
export function stylesDuPanneau(stylesAppelant = {}) {
  return {
    ...stylesAppelant,
    body: { ...CORPS_DEFILANT, ...(stylesAppelant.body) },
    content: { boxShadow: ELEVATION, ...(stylesAppelant.content) },
  };
}
